import { createContext, type ReactNode } from 'react';

/**
 * Absolute path where the login package's screens are mounted in the consumer's
 * route tree. Defaults to `/` — correct for the standalone deploy, where login
 * screens live at the app root.
 *
 * A consumer that mounts login under a subpath (e.g. VidaReactNative at
 * `/auth/apigee/`) must wrap the login sub-tree in <LoginMountProvider mountBase='/auth/apigee'/>
 * (or the bundled <LoginRoot mountBase='/auth/apigee'/>). Login's internal
 * navigation reads this to resolve the relative paths in ROUTES to absolute
 * paths — required because Expo Router's imperative router.push('./x') does
 * not reliably resolve relative paths on native.
 */
export const LoginMountContext = createContext<string>('/');

type LoginMountProviderProps = {
  mountBase?: string;
  children: ReactNode;
};

export const LoginMountProvider = ({ mountBase = '/', children }: LoginMountProviderProps) => (
  <LoginMountContext.Provider value={mountBase}>{children}</LoginMountContext.Provider>
);
